<template>
  <div class="columns padding-top10">
    <div class="column col-10">
      <InputWrapper :errors="errorMap($appErrors, 'title')">
        <label class="form-label">Naslov</label>
        <InputText v-model="data.title" />
      </InputWrapper>
      <InputWrapper :errors="errorMap($appErrors, 'text')">
        <label class="form-label">Besedilo</label>
        <InputTextArea style="height: 400px !important" v-model="data.text" />
      </InputWrapper>
    </div>
    <div class="column col-2">
      <InputWrapper :errors="errorMap($appErrors, 'date')">
        <label class="form-label">Datum</label>
        <InputDate v-model="data.date" />
      </InputWrapper>
      <div class="columns padding-top10">
        <div class="column col-6">
          <InputWrapper :errors="errorMap($appErrors, 'active')">
            <label class="form-label">Aktivnost</label>
            <InputCheck v-model="data.active" />
          </InputWrapper>
        </div>
        <div class="column col-6">
          <InputWrapper :errors="errorMap($appErrors, 'new')">
            <label class="form-label">Novo</label>
            <InputCheck v-model="data.new" />
          </InputWrapper>
        </div>
      </div>
    </div>
  </div>

  <div class="clearfix padding-bottom20 padding-top20">
    <button class="button" @click.prevent="submit()">Shrani</button>
    <button class="button trans pull-right" @click.prevent="$router.push({ name: 'adminNews' })">Nazaj</button>
  </div>
</template>

<script lang="ts">
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputText from '@/components/common/InputText.vue'
import InputDate from '@/components/common/InputDate.vue'
import InputCheck from '@/components/common/InputCheck.vue'
import InputTextArea from '@/components/common/InputTextArea.vue'

import { useApi } from '@/lib/api'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { errorMap } from '@/lib/filters'
import { useRoute } from 'vue-router'
import { useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { InputWrapper, InputText, InputDate, InputTextArea, InputCheck },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _route = useRoute()
    const _inst = getCurrentInstance()
    const data = ref({})

    const getData = async () => {
      const res = await _api.get<any>('adminNews?id=' + _route.params.id)
      data.value = res.data
      setRecord('adminNewsList' + _route.params.id)
    }

    const submit = async () => {
      const res = await _api.post<any>('adminNewsWrite', data.value)
      if (res.status === 200) {
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Novica shranjena.' })
        data.value = res.data
      }
    }

    if (_route.params.id !== '-1') {
      getData()
    }

    return { data, errorMap, submit }
  }
})
</script>

<style lang="scss"></style>
